export const validationStatus = {
  draft: 'Draft',
  draft_rejected: 'Draft (Rejected)',
  val_1_2: 'Validation (1/2)',
  val_2_2: 'Validation (2/2)',
  validated: 'Validated',
};
